const classification = [
  { label: 'INTL', value: 'INTL' },
  { label: 'MIL', value: 'MIL' },
  { label: 'DOM', value: 'DOM' },
  { label: 'LMIL', value: 'LMIL' },
  { label: 'FDC', value: 'FDC' },
]

export default classification
